/*
 * Note visibility options
 * Features: Stable access-level values and presentation-only audience descriptions.
 * Implementation: Authorization uses numeric levels; helper wording can change independently.
 * Recent changes: Adds the four hierarchical levels for RLP notes and Admin; Commercial/Prospect retain teams.
 */

export type AccessLevel = 1 | 2 | 3 | 4;
export type NoteVisibilityMode = 'teams' | 'levels';

export const NOTE_ACCESS_LEVELS = [
  { value: 1, label: 'lvl1', helpText: 'Visible to all CRM users.' },
  { value: 2, label: 'lvl2', helpText: 'Visible to managers/leads, VPs, CEO and President.' },
  { value: 3, label: 'lvl3', helpText: 'Visible to VPs, CEO and President.' },
  { value: 4, label: 'lvl4', helpText: 'Visible to CEO and President.' },
] as const;

export const isAccessLevel = (value: unknown): value is AccessLevel =>
  typeof value === 'number' && Number.isInteger(value) && value >= 1 && value <= 4;
